<script>
  import { user } from "../firebase";
  import { lang } from "../store/store";
  import { router } from "tinro";
  import { onDestroy } from "svelte";
  let loaded = false;
  let doc = {};
  let unsubscribeDoc;

  console.log("GUARRAAARDDDD");
  const unsubscribeUser = user.subscribe((v) => {
    if (v === undefined) {
      return;
    }
    if (v === null) {
      loaded = false;
      router.goto("/login");
      return;
    }

    loaded = true;
  });

  onDestroy(() => {
    unsubscribeUser();
  });
</script>

{#if loaded}
  <slot />
{/if}

<style>
</style>
